import { Box, Tab } from "@mui/material"
import { useCallback, useEffect, useMemo, useState } from "react"
import { HuddleHeader, NavigationAssistant, StyledTabsList } from "./Atom"
import {
  fetchContracts,
  fetchGroupsHandler,
  fetchLabExpenses,
  fetchOfficesHandler,
  fetchPayroll,
  fetchRegionsHandler,
  fetchSummary,
  fetchYearList,
  fetchContractDoctors,
  fetchActiveProviders,
} from "./apiUtils"
import { useAppDispatch } from "../../redux/hooks"
import {
  assignTableId,
  csvConfig,
  getTokenLocal,
  transformDataCSV,
} from "../../../helper/utils"
import { useNavigate } from "react-router-dom"
import { setLoading, setOpenSidebar } from "../../redux/slices/appSlice"
import {
  setMaevaGroups,
  setMaevaPractices,
  setMaevaRegions,
  setMaevaSelectedPractices,
} from "../../redux/slices/metricSlice"
import { useSelector } from "react-redux"
import { DoctorCompensationTabs } from "../../components/Tabs"
import DoctorCompensationTable from "../../components/Table/DoctorCompensationTable"
import {
  setContractData,
  setCurrentContract,
  setDoctorList,
  setLabExpensesData,
  setPayrollData,
  setProviderList,
  setSelectedDoctorCompensationTab,
  setSummaryData,
  setYearList,
  setDoctorCompensationTabs,
} from "../../redux/slices/doctorCompensationSlice"
import CreateUpdateContractModal from "../../components/Modal/CreateUpdateContract"
import { toast } from "react-toastify"
import DoctorCompensationAPI from "../../../api/doctorCompensation"
import { SimpleConfirmation } from "../../components/Modal/Reusable"
import { TabContext, TabPanel } from "@mui/lab"
import SummaryTable from "../../components/Table/DoctorCompensationTable/SummaryTable"
import PayrollTable from "../../components/Table/DoctorCompensationTable/PayrollTable"
import LabExpensesTable from "../../components/Table/DoctorCompensationTable/LabExpensesTable"
import moment from "moment"
import jsPDF from "jspdf"
import { MRT_ColumnDef } from "material-react-table"
import autoTable from "jspdf-autotable"
import { createColumn, createSummaryColumn } from "./tableConfig"
import { amountFormatter, percentFormatter } from "./tableConfig"
import { strMonths } from "./MultiSelectDropdown"
import { mkConfig, generateCsv, download } from "export-to-csv"
import { OfficeText } from "../../components/Table/OpportunityDashboardTable/Atom"

const doctorCompensationAPI = new DoctorCompensationAPI()

const DoctorCompensation = () => {
  const token = getTokenLocal()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  dispatch(setOpenSidebar(false))

  const downloadSelection = useSelector((state: any) => {
    return state.app.exportPdfCsvSelection
  })
  let summaryTableColumn: any[] = createSummaryColumn()
  let summaryTableData: any = useSelector(
    (state: any) => state.doctorCompensation?.summaryData,
  )

  let payrollTableColumn: any[] = createColumn()
  let payrollTableData: any = useSelector(
    (state: any) => state.doctorCompensation?.payrollData,
  )

  let labExpensesTableColumn: any[] = createColumn()
  let labExpensesTableData: any = useSelector(
    (state: any) => state.doctorCompensation?.labExpensesData,
  )

  const currentLoggedInUser = useSelector(
    (state: any) => state.admin.currentUser,
  )
  const maevaPractices = useSelector((state: any) => {
    return state.metric.maevaPractices
  })
  const maevaSelectedGroup = useSelector((state: any) => {
    return state.metric.maevaSelectedGroupsNoAll?.[0]
  })
  const maevaSelectedRegion = useSelector((state: any) => {
    return state.metric.maevaSelectedRegionsNoAll?.[0]
  })
  const maevaSelectedPractice = useSelector((state: any) => {
    return state.metric.maevaSelectedPractices?.[0]
  })
  const selectedDoctorCompensationTab = useSelector((state: any) => {
    return state.doctorCompensation.selectedDoctorCompensationTab
  })
  const selectedProvider = useSelector((state: any) => {
    return state.doctorCompensation.selectedProvider[0]
  })
  const selectedStatus = useSelector((state: any) => {
    return state.doctorCompensation.selectedStatus[0]
  })
  const currentContract: any = useSelector(
    (state: any) => state.doctorCompensation.currentContract,
  )
  const selectedYear = useSelector((state: any) => {
    return state.doctorCompensation.selectedYear[0]
  })
  const selectedMonth = useSelector((state: any) => {
    return state.doctorCompensation?.selectedMonth
  })

  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [openConfirmation, setOpenConfirmation] = useState<any>(false)
  const [currentCompPlanId, setCurrentCompPlanId] = useState<any>(null)
  const [type, setType] = useState<"create" | "edit">("create")
  const [valueTab, setValueTab] = useState("1")

  const contractData = useSelector(
    (state: any) => state.doctorCompensation.contractData,
  )

  const columns: MRT_ColumnDef<any>[] = [
    {
      header: "Doctor Name",
      accessorKey: "provider_name",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ row, cell, renderedCellValue }) => (
        <OfficeText>
          <span style={{ fontSize: "14px" }}> {renderedCellValue}</span>
          <span style={{ fontSize: "10px", color: "#a1a1a1" }}>
            {row.original.practice_name}
          </span>
        </OfficeText>
      ),
      muiTableBodyCellProps: {
        align: "left",
        sx: {
          border: "0.5px solid #E4E4E4",
          boxShadow: "#00000022 1.95px 0px 2.6px",
          color: "black",
          fontWeight: "600",
        },
      },
      editVariant: "select",
      editSelectOptions: [
        { label: "Elana Shlansky", value: "Elana Shlansky" },
        { label: "Richard Fordjour", value: "Richard Fordjour" },
        { label: "Toshar Taneja", value: "Toshar Taneja" },
        { label: "Michael Katsaros", value: "Michael Katsaros" },
      ],
    },
    {
      header: "Doctor Comp Plan",
      accessorKey: "comp_plan_type",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "select",
      editSelectOptions: [
        { label: "Net Production", value: "Net Production" },
        { label: "Gross Production", value: "Gross Production" },
        { label: "Collections", value: "Collections" },
        { label: "Flat Salary", value: "Flat Salary" },
      ],
    },
    {
      header: "Memo",
      accessorKey: "qbo_memo",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Compensation Account",
      accessorKey: "compensation_account",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Bonus Account",
      accessorKey: "bonus_account",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Comp Plan Start Date",
      accessorKey: "plan_start_date",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Comp Plan End Date",
      accessorKey: "plan_end_date",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Guarantee",
      accessorKey: "guarantee_yes_no",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "select",
      editSelectOptions: [
        { label: "Yes", value: "Yes" },
        { label: "No", value: "No" },
      ],
    },
    {
      header: "Guarantee Type",
      accessorKey: "guarantee_type",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Guarantee Start Date",
      accessorKey: "guarantee_start_date",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Guarantee End Date",
      accessorKey: "guarantee_end_date",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Guarantee $",
      accessorKey: "guarantee_amount",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: amountFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Commission When Over Guarantee Y/N",
      accessorKey: "commission_over_guarantee_yes_no",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: ({ cell, renderedCellValue }) =>
        renderedCellValue || "0" ? renderedCellValue : renderedCellValue,
      editVariant: "select",
      editSelectOptions: [
        { label: "Yes", value: "Yes" },
        { label: "No", value: "No" },
      ],
    },
    {
      header: "Lab %",
      accessorKey: "lab_percent",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: percentFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 1 %",
      accessorKey: "tier_1_comp_percent",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: percentFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 1 $",
      accessorKey: "tier_1_comp_max_amount",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: amountFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 2 %",
      accessorKey: "tier_2_comp_percent",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: percentFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 2 $",
      accessorKey: "tier_2_comp_max_amount",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: amountFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 3 %",
      accessorKey: "tier_3_comp_percent",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: percentFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 3 $",
      accessorKey: "tier_3_comp_max_amount",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: amountFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 4 %",
      accessorKey: "tier_4_comp_percent",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: percentFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 4 $",
      accessorKey: "tier_4_comp_max_amount",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: amountFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 5 %",
      accessorKey: "tier_5_comp_percent",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: percentFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
    {
      header: "Tier 5 $",
      accessorKey: "tier_5_comp_max_amount",
      muiTableHeadCellProps: {
        align: "left",
      },
      Cell: amountFormatter,
      editVariant: "text",
      editSelectOptions: [],
    },
  ]

  // columns.forEach((element) => {
  //   if (element.editVariant === "select") {
  //     element.editSelectOptions = [
  //       { label: "Yes", value: "Yes" },
  //       { label: "No", value: "No" },
  //     ]
  //   }
  // })

  // dialog handlers
  const openCreateContractDialog = () => setOpenDialog(true)
  const closeCreateContractDialog = async () => {
    setType("create")
    setOpenDialog(false)
  }

  // confirmation handlers
  const closeDeleteContractConfirmation = () => setOpenConfirmation(false)
  const openDeleteContractConfirmation = () => setOpenConfirmation(true)

  // state setter handlers
  const editOpenHandler = async (contract: any) => {
    setType("edit")
    dispatch(setCurrentContract(contract))
    openCreateContractDialog()
  }
  const deleteOpenHandler = (compPlanId: any) => {
    setCurrentCompPlanId(compPlanId)
    openDeleteContractConfirmation()
  }

  const fetchContractsHandler = async () => {
    if (maevaSelectedRegion && maevaSelectedPractice) {
      fetchContracts({
        token,
        dispatch: (payload: any) => {
          dispatch(setContractData(payload))

          if (payload.length) {
            dispatch(
              setDoctorCompensationTabs([
                {
                  index: 0,
                  id: "compensation",
                  name: "Compensation",
                },
                {
                  index: 1,
                  id: "reporting",
                  name: "Reporting",
                },
              ]),
            )
          } else {
            dispatch(
              setDoctorCompensationTabs([
                {
                  index: 0,
                  id: "compensation",
                  name: "Compensation",
                },
              ]),
            )
          }
        },
        navigate,
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
        office: maevaSelectedPractice,
        status: selectedStatus,
        provider: selectedProvider,
      })
    }
  }

  const fetchReportingHandler = async () => {
    if (selectedMonth.length > 0) {
      fetchSummary({
        token,
        dispatch: (payload: any) => {
          // dispatch(setSummaryColumns(payload?.column_headers))
          dispatch(setSummaryData(payload))
        },
        navigate,
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
        office: maevaSelectedPractice,
        year: selectedYear,
        month: selectedMonth,
        memo: selectedProvider,
      })
      fetchPayroll({
        token,
        dispatch: (payload: any) => {
          // dispatch(setPayrollColumns(payload?.column_headers))
          dispatch(setPayrollData(payload))
        },
        navigate,
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
        office: maevaSelectedPractice,
        year: selectedYear,
        month: selectedMonth,
        memo: selectedProvider,
      })
      fetchLabExpenses({
        token,
        dispatch: (payload: any) => {
          // dispatch(setLabExpensesColumns(payload?.column_headers))
          dispatch(setLabExpensesData(payload))
        },
        navigate,
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
        office: maevaSelectedPractice,
        year: selectedYear,
        month: selectedMonth,
        memo: selectedProvider,
      })
      // fetchJournalEntries({
      //   token,
      //   dispatch: (payload: any) => {
      //     dispatch(setJournalEntriesColumns(payload?.column_headers))
      //     dispatch(setJournalEntriesData(payload?.doc_journal_entries_data))
      //   },
      //   navigate,
      //   loading,
      //   group: maevaSelectedGroup,
      //   region: maevaSelectedRegion,
      //   office: maevaSelectedPractice,
      //   year: selectedYear,
      //   month: selectedMonth,
      //   memo: selectedMemo,
      // })
    }
  }

  const createContractHandler = async (data: any, cleanUpHandler: any) => {
    loading(true)
    if (token) {
      const payload = {
        ...data,
        practice_sk: maevaSelectedPractice?.practice_sk,
      }

      console.log("data", data)

      const result: any = await doctorCompensationAPI.createContract(
        token,
        payload,
      )
      if (
        result?.data?.status_code != 200 &&
        result?.data?.status_code != 401
      ) {
        toast.error(result?.data?.display_message)
        await fetchContractsHandler()
      } else {
        toast.success(result?.data?.display_message)
        await fetchContractsHandler()
      }
    }
    loading(false)
    cleanUpHandler()
  }

  const updateContractHandler = async (data: any, cleanUpHandler: any) => {
    loading(true)
    if (token) {
      const payload = {
        ...data,
      }

      const result: any = await doctorCompensationAPI.updateContract(
        token,
        currentContract?.comp_plan_id,
        payload,
      )
      if (
        result?.data?.status_code != 200 &&
        result?.data?.status_code != 401
      ) {
        toast.error(result?.data?.display_message)
        await fetchContractsHandler()
      } else {
        toast.success(result?.data?.display_message)
        await fetchContractsHandler()
      }
    }
    loading(false)
    cleanUpHandler()
  }

  const deleteContractHandler = async () => {
    loading(true)
    if (token) {
      const result: any = await doctorCompensationAPI.deleteContract(
        token,
        currentCompPlanId,
      )
      if (
        result?.data?.status_code != 200 &&
        result?.data?.status_code != 401
      ) {
        toast.error(result?.data?.display_message)
        await fetchContractsHandler()
      } else {
        toast.success(result?.data?.display_message)
        await fetchContractsHandler()
      }
    }
    loading(false)
    closeDeleteContractConfirmation()
  }

  const loading = useCallback((loadVal: boolean) => {
    dispatch(setLoading(loadVal))
  }, [])

  useEffect(() => {
    fetchGroupsHandler({
      token,
      dispatch: (payload: any) => {
        dispatch(setMaevaGroups(payload))
      },
      navigate,
      loading,
    })
  }, [])

  useEffect(() => {
    if (maevaSelectedGroup) {
      fetchRegionsHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaRegions(payload))
        },
        navigate,
        group: maevaSelectedGroup,
        loading,
      })
    }
  }, [maevaSelectedGroup])

  useEffect(() => {
    if (maevaSelectedRegion) {
      fetchOfficesHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaPractices(payload))
        },
        navigate,
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
        selectedDoctorCompensationTab: selectedDoctorCompensationTab,
      })
    }
  }, [maevaSelectedRegion])

  useEffect(() => {
    fetchContractsHandler()
  }, [
    maevaSelectedRegion,
    maevaSelectedPractice,
    selectedProvider,
    selectedStatus,
  ])

  useEffect(() => {
    if (maevaSelectedPractice) {
      fetchActiveProviders({
        token,
        dispatch: (payload: any) => {
          let localArr: any = []
          payload.forEach((doctor: any) => {
            localArr.push(doctor.provider_name)
          })
          dispatch(setDoctorList(localArr))
        },
        navigate,
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
        office: maevaSelectedPractice,
      })
      fetchContractDoctors({
        token,
        dispatch: (payload: any) => {
          let localArr: any = [{ label: "All", name: "all" }]
          payload.forEach((doctor: any) => {
            localArr.push({
              label: doctor.provider_name,
              name: doctor.provider_name,
              ...doctor,
            })
          })
          dispatch(setProviderList(localArr))
        },
        navigate,
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
        office: maevaSelectedPractice,
      })
    }
  }, [maevaSelectedPractice])

  useEffect(() => {
    if (maevaSelectedPractice) {
      fetchYearList({
        token,
        dispatch: (payload: any) => {
          let localArr: any = []
          payload.forEach((year: any) => {
            localArr.push({ label: year, name: year })
          })
          // Sort years in descending order (most recent first)
          localArr.sort((a: any, b: any) => {
            const yearA = parseInt(a.label)
            const yearB = parseInt(b.label)
            return yearB - yearA
          })
          dispatch(setYearList(localArr))
        },
        navigate,
        loading,
        office: maevaSelectedPractice,
      })
    }
  }, [maevaSelectedPractice])

  // useEffect(() => {
  //   if (selectedMonth.length > 0) {
  //     fetchSummaryMemoList({
  //       token,
  //       dispatch: (payload: any) => {
  //         let localArr: any = [{ label: "All", name: "all" }]
  //         payload.forEach((memo: any) => {
  //           localArr.push({
  //             label: memo.provider_name,
  //             name: memo.provider_name,
  //           })
  //         })
  //         dispatch(setSummaryMemoList(localArr))
  //       },
  //       navigate,
  //       loading,
  //       office: maevaSelectedPractice,
  //     })
  //     fetchQboMemoList({
  //       token,
  //       dispatch: (payload: any) => {
  //         let localArr: any = [{ label: "All", name: "all" }]
  //         payload.forEach((memo: any) => {
  //           localArr.push({ label: memo.qbo_memo, name: memo.qbo_memo })
  //         })
  //         dispatch(setQboMemoList(localArr))
  //       },
  //       navigate,
  //       loading,
  //       office: maevaSelectedPractice,
  //     })
  //   }
  // }, [selectedMonth])

  useEffect(() => {
    if ((selectedMonth.length > 0, selectedProvider)) {
      fetchReportingHandler()
    }
  }, [selectedMonth, selectedProvider])

  const navigationData = useMemo(
    () => [
      {
        label: "Select a group to proceed",
        value: maevaSelectedGroup ? true : false,
      },
      {
        label: "Select a region to proceed",
        value: maevaSelectedRegion ? true : false,
      },
      {
        label: "Select an office to proceed",
        value: maevaSelectedPractice ? true : false,
      },
      {
        label: "Select a year to proceed",
        value: selectedYear ? true : false,
      },
      {
        label: "Select a month to proceed",
        value: selectedMonth ? true : false,
      },
    ],
    [
      maevaSelectedGroup,
      maevaSelectedRegion,
      maevaSelectedPractice,
      selectedProvider,
      selectedYear,
    ],
  )

  const addHeaders = (doc: any, heading: string, tab: string) => {
    doc.text(heading, doc.internal.pageSize.width / 2, 10, {
      align: "center",
    })

    const group: string = `Group - ${maevaSelectedGroup?.group_name}`
    const region: string = `Region - ${maevaSelectedRegion?.label}`
    const practice: string = `Practice - ${maevaSelectedPractice?.label}`
    const provider: string = `Provider - ${selectedProvider?.label}`
    const status: string = `Status - ${selectedStatus?.label}`
    const year: string = `Year - ${selectedYear?.label}`
    const month: string = `Month - ${selectedMonth?.map(
      (ele: number) => ` ${strMonths[ele - 1]}`,
    )}`
    const memo: string = `Memo - ${selectedProvider?.label}`
    const summaryDoctor: string = `Summary Doctor - ${selectedProvider?.label}`
    const exportedBy: string = `Exported By - ${currentLoggedInUser?.first_name} ${currentLoggedInUser?.last_name}`
    const exportedAt: string = `Exported At - ${moment().format(
      "MM DD YYYY, h:mm a",
    )}`

    doc.setFont("Courier")
    doc.setFontSize(8)

    doc.text(
      `${group} | ${region} | ${practice}`,
      doc.internal.pageSize.width / 2,
      18,
      {
        align: "center",
      },
    )

    tab === "contract"
      ? doc.text(
          `${provider} | ${status}`,
          doc.internal.pageSize.width / 2,
          24,
          {
            align: "center",
          },
        )
      : doc.text(
          `${year} | ${month} | ${memo} | ${summaryDoctor}`,
          doc.internal.pageSize.width / 2,
          24,
          {
            align: "center",
          },
        )

    doc.text(
      `${exportedBy} | ${exportedAt}`,
      doc.internal.pageSize.width / 2,
      32,
      {
        align: "center",
      },
    )
  }

  const addFooters = (doc: any) => {
    const pageCount = doc.internal.getNumberOfPages()

    doc.setFont("helvetica", "italic")
    doc.setFontSize(8)

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.text(
        "Page " + String(i) + " of " + String(pageCount),
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 10,
        {
          align: "center",
        },
      )
    }
  }

  const handleDoctorCompensationDownload = () => {
    const doc = new jsPDF("landscape") as any
    addHeaders(doc, "Doctor Compensation", "contract")

    autoTable(doc, {
      html:
        assignTableId(
          "doctor-compensation-contracts",
          "doctor-compensation-contracts-table",
        ) || "",
      startY: 45,
      styles: {
        fontSize: 8,
      },
    })
    addFooters(doc)

    doc.save(`doctor_compensation.pdf`)
  }

  const handleDoctorCompensationDownloadCSV = () => {
    const config = mkConfig(
      csvConfig("Doctor_Compensation", "Doctor Compensation"),
    )

    const csvData = generateCsv(config)(
      transformDataCSV(columns, contractData || []),
    )
    download(config)(csvData)
  }

  const handleReportingDownload = () => {
    const doc = new jsPDF("landscape") as any
    let currentY = 50

    // addHeaders(doc, "Doctor Reporting", "reporting")

    addHeaders(
      doc,
      `Doctor Reporting | ${
        valueTab === "1"
          ? "Summary"
          : valueTab === "2"
          ? "Payroll"
          : valueTab === "3"
          ? "Lab Expenses"
          : ""
      }`,
      "reporting",
    )
    switch (valueTab) {
      case "1":
        autoTable(doc, {
          html: assignTableId("summary", "summary-table") || "",
          startY: 45, // Adjust startY based on currentY position
        })
        addFooters(doc)
        doc.save(`doctor_reporting_summary.pdf`)
        break
      case "2":
        autoTable(doc, {
          html: assignTableId("payroll", "payroll-table") || "",
          startY: 45, // Adjust startY based on currentY position
        })
        addFooters(doc)
        doc.save(`doctor_reporting_payroll.pdf`)
        break
      case "3":
        autoTable(doc, {
          html: assignTableId("lab-expenses", "lab-expenses-table") || "",
          startY: 45, // Adjust startY based on currentY position
        })
        addFooters(doc)
        doc.save(`doctor_reporting_lab_expenses.pdf`)
        break
      default:
        break
    }

    // doc.setFontSize(14)
    // doc.text("Journal Entries", doc.internal.pageSize.width / 2, currentY, {
    //   align: "center",
    // })

    // currentY += 5

    // let doctorJournalEntriesTableData: any = []
    // let doctorJournalEntriesTableColumns: any = []

    // if (journalEntriesTableData) {
    //   ;({
    //     headers: doctorJournalEntriesTableColumns,
    //     dataArray: doctorJournalEntriesTableData,
    //   } = extractTableData(
    //     journalEntriesTableColumn,
    //     journalEntriesTableData || [],
    //   ))
    // }

    // autoTable(doc, {
    //   head: [doctorJournalEntriesTableColumns],
    //   body: doctorJournalEntriesTableData,
    //   startY: currentY + 5,
    //   styles: {
    //     fontSize: 8,
    //   },
    // })
  }

  const handleReportingDownloadCSV = () => {
    const config = mkConfig(
      csvConfig("Doctor_Reporting_Summary", "Doctor Reporting Summary"),
    )
    const csvData = generateCsv(config)(
      transformDataCSV(summaryTableColumn, summaryTableData || []),
    )
    download(config)(csvData)

    const config2 = mkConfig(csvConfig("Doctor_Payroll", "Doctor Payroll"))
    const csvData2 = generateCsv(config2)(
      transformDataCSV(payrollTableColumn, payrollTableData || []),
    )
    download(config2)(csvData2)

    const config3 = mkConfig(
      csvConfig("Doctor_Lab_Expenses", "Doctor Lab Expenses"),
    )
    const csvData3 = generateCsv(config3)(
      transformDataCSV(labExpensesTableColumn, labExpensesTableData || []),
    )
    download(config3)(csvData3)
  }
  const fetchByDoctorCompensationTabId = (tab: any) => {
    switch (tab?.id) {
      case "compensation": {
        let arr = [...maevaPractices]

        arr.unshift({ label: "All", name: "All", practice_sk: "all" })
        dispatch(setMaevaPractices(arr))
        if (!maevaSelectedPractice) {
          dispatch(
            setMaevaSelectedPractices([
              { label: "All", name: "All", practice_sk: "all" },
            ]),
          )
        }
        dispatch(setSelectedDoctorCompensationTab(tab))
        break
      }
      case "reporting": {
        let arr = [...maevaPractices]
        arr.shift()
        if (maevaSelectedPractice?.label == "All") {
          dispatch(setMaevaSelectedPractices([]))
        }
        dispatch(setMaevaPractices(arr))
        dispatch(setSelectedDoctorCompensationTab(tab))
        break
      }
    }
  }

  const handleChangeTab = (
    event: React.SyntheticEvent,
    newValueTab: string,
  ) => {
    setValueTab(newValueTab)
  }

  return (
    <>
      <Box
        sx={{
          // border: "1px solid red",
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          height: "100%",
          backgroundColor: "#F8F9FA",
        }}
      >
        <HuddleHeader
          name="Doctor Compensation"
          setOpen={setOpenDialog}
          reportingTab={valueTab}
          handleDownload={
            downloadSelection === "PDF"
              ? selectedDoctorCompensationTab?.id == "compensation"
                ? handleDoctorCompensationDownload
                : selectedDoctorCompensationTab?.id == "reporting"
                ? handleReportingDownload
                : null
              : downloadSelection === "CSV"
              ? selectedDoctorCompensationTab?.id == "compensation"
                ? handleDoctorCompensationDownloadCSV
                : selectedDoctorCompensationTab?.id == "reporting"
                ? handleReportingDownloadCSV
                : null
              : null
          }
        />
        {maevaSelectedRegion ? (
          <>
            <Box sx={{ padding: "0 25px" }}>
              <DoctorCompensationTabs
                fetchByTabId={fetchByDoctorCompensationTabId}
              />
            </Box>
            {selectedDoctorCompensationTab?.id == "compensation" ? (
              <Box id="doctor-compensation-contracts">
                <DoctorCompensationTable
                  columns={columns}
                  data={contractData}
                  handleEditOpen={editOpenHandler}
                  handleDeleteOpen={deleteOpenHandler}
                />
              </Box>
            ) : selectedYear && selectedMonth.length > 0 ? (
              <Box sx={{ margin: "0px 25px" }}>
                <TabContext value={valueTab}>
                  <StyledTabsList
                    aria-label="UMTabs"
                    onChange={handleChangeTab}
                  >
                    <Tab label="Summary" value="1" disableRipple />
                    <Tab label="Payroll" value="2" disableRipple />
                    <Tab label="Lab Expenses" value="3" disableRipple />
                    {/* <Tab label="Journal Entries" value="4" disableRipple /> */}
                  </StyledTabsList>
                  <TabPanel
                    value="1"
                    sx={{ height: "60vh", padding: 0 }}
                    id="summary"
                  >
                    <SummaryTable
                      columns={summaryTableColumn}
                      data={summaryTableData}
                    />
                  </TabPanel>
                  <TabPanel
                    value="2"
                    sx={{ height: "60vh", padding: 0 }}
                    id="payroll"
                  >
                    <PayrollTable
                      columns={payrollTableColumn}
                      data={payrollTableData}
                    />
                  </TabPanel>
                  <TabPanel
                    value="3"
                    sx={{ height: "60vh", padding: 0 }}
                    id="lab-expenses"
                  >
                    <LabExpensesTable
                      columns={labExpensesTableColumn}
                      data={labExpensesTableData}
                    />
                  </TabPanel>
                  {/* <TabPanel value="4" sx={{ height: "60vh", padding: 0 }}>
                    <JournalEntriesTable
                      columns={journalEntriesTableColumn}
                      data={journalEntriesTableData}
                    /> */}
                  {/* </TabPanel> */}
                </TabContext>
              </Box>
            ) : (
              <NavigationAssistant data={navigationData} />
            )}
          </>
        ) : (
          <NavigationAssistant data={navigationData} />
        )}
      </Box>
      <CreateUpdateContractModal
        open={openDialog}
        type={type}
        createHandler={createContractHandler}
        updateHandler={updateContractHandler}
        closeHandler={closeCreateContractDialog}
      />
      <SimpleConfirmation
        open={openConfirmation}
        setOpen={setOpenConfirmation}
        title="Delete contract"
        optionalMessage="Are you sure to delete this contract"
        buttonText="Delete"
        confirmActionHandler={deleteContractHandler}
      />
    </>
  )
}

export default DoctorCompensation
